import Estructura from "./estructura";
import { postFormQuestionaryAPI } from "../../api";
import { verifyResponses, inArrayCheckCode } from "./functions";
import { changeSubMenu, getListadoPlanesMovilidad, onAlertaPlanMovilidad } from "../../actions";
import error from "../../../config/mensajesError";


const erroresServicios = code => {
  switch (code) {
    case 400: return error.E400;
    case 403: return error.E403;
    case 404: return error.E404;
    case 500: return error.E500;
    case 504: return error.E504;
    case 509: return error.E509;
    default: return error.otro;
  }
}

export const loadQuestionary = () => ({
  type: "LOAD_QUESTIONARY",
  encuestaData: Estructura,
});

export const addResponse = (pregunta, respuesta) => ({
  type: "ADD_RESPONSE_QUESTIONARY",
  pregunta,
  respuesta,
});

export const removeResponse = (pregunta, respuesta) => ({
  type: "REMOVE_RESPONSE_QUESTIONARY",
  pregunta,
  respuesta,
});

export const addComposite = (pregunta, respuesta, texto) => ({
  type: "ADD_COMPOSITE_QUESTIONARY",
  pregunta,
  respuesta,
  texto,
});

export const addNumber = (pregunta, texto) => ({
  type: "ADD_NUMBER_QUESTIONARY",
  pregunta,
  texto,
});

export const addText = (pregunta, texto) => ({
  type: "ADD_TEXT_QUESTIONARY",
  pregunta,
  texto,
});

export const sendFormQuestionary = (idPlanMovilidad, preguntas, respuestas, empresaID, centroID, usuarioRUT, centroName, centroTipo, cantidadHombresCentro, cantidadMujeresCentro) => async (dispatch) => {
  dispatch(isFormLoading(true));

  // agrego el valor si viene, para luego pasar por la verificación
  if ( (parseInt(cantidadHombresCentro) + parseInt(cantidadMujeresCentro) > 0) && !inArrayCheckCode(respuestas, "Q5") ){
    respuestas = respuestas.concat({
      code: "Q5",
      response: ["a", "b"],
      responseadicional: [cantidadHombresCentro, cantidadMujeresCentro],
      type: "COMPOSITE",
    });
  }

  // función que registra que estén todas las respuestas respondidas.
  const alerta = verifyResponses(preguntas, respuestas);
  if (alerta !== "" && alerta !== null) {
    dispatch(onAlertaPlanMovilidad("error", alerta));
  } else {
    // agrego las preguntas por defecto;
    respuestas = respuestas.concat({
      code: "Q2",
      response: [centroTipo],
      type: "JUST_ONE",
    });

    respuestas = respuestas.concat({
      code: "Q3",
      response: [centroName],
      type: "TEXT",
    });

    try {
      const request = await postFormQuestionaryAPI(idPlanMovilidad, respuestas);
      if (request.status === 200) {
        const result = await request.json();
        if (result.operationCode === 1) {
          dispatch(changeSubMenu(0));
          //dispatch(onAlertaPlanMovilidad("success", result.operationMessage));
          dispatch(onAlertaPlanMovilidad("success", "¡Gracias por responder esta encuesta! A continuación procesaremos esta información con la que recibamos de los trabajadores, lo que nos permitirá generar un informe de diagnóstico que será la base del plan de movilidad para tu centro de trabajo. "));
          dispatch(getListadoPlanesMovilidad(empresaID, centroID, usuarioRUT));
        } else {
          dispatch(onAlertaPlanMovilidad("error", result.operationMessage));
        }
      }else {
        dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
      }
    } catch (error) {
      dispatch(onAlertaPlanMovilidad("error", "Error con la API [postFormQuestionaryAPI] de envío de Encuesta, consulte a un administador.", ));
    }
  }

  dispatch(isFormLoading(false));
};

const isFormLoading = (isLoading) => ({
  type: "LOADING_SEND_QUESTIONARY",
  isLoading,
});

export const resetResponses = () => ({
  type: "RESET_RESPONSES_QUESTIONARY",
});
